import React from "react";

import "./cta-primary.scss"

function CtaPrimary({ text, onClick }) {
    return(
        <button className="cta-primary" onClick={onClick}>{text}</button>
    )
}

export default CtaPrimary